module.exports = "<div class=\"kan-dog-list\">\n    <!--<div class=\"kan-spinner-container\"-->\n         <!--*ngIf=\"loading\">-->\n        <!--<mat-spinner color=\"primary\"></mat-spinner>-->\n    <!--</div>-->\n    <kan-dog-list-item *ngFor=\"let dog of dogs\"\n                       [dog]=\"dog\"\n                       [searchText]=\"searchText\"\n                       (refresh)=\"emitRefresh()\">\n    </kan-dog-list-item>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/components/dog/list/component.html
// module id = ./src/modules/admin/components/dog/list/component.html
// module chunks = main